module.exports = __webpack_public_path__ + "img/2nd(1).ec70e7b4.png";